interface CoHostBannerProps {
  className?: string;
}

export function CoHostBanner({ className = '' }: CoHostBannerProps) {
  return (
    <div
      className={`bg-orange-50 text-[#FC480D] text-[11px] font-bold tracking-wide text-center py-1.5 px-3 ${className}`}
    >
      Kamu mengelola sebagai Co-Host
    </div>
  );
}
